import { render, staticRenderFns } from "./HomeFeature.vue?vue&type=template&id=15996f68&scoped=true&"
import script from "./HomeFeature.vue?vue&type=script&lang=ts&"
export * from "./HomeFeature.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFeature.vue?vue&type=style&index=0&id=15996f68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15996f68",
  null
  
)

export default component.exports